import { ReactNode, RefObject } from 'react';
import { HStack, StackProps, Stat as ChakraStatNamespace, StatRootProps } from '@chakra-ui/react';

import { FormatValue, FormatValueProps } from '@oaknorth/util-intl';

interface StatLabelProps extends ChakraStatNamespace.LabelProps {
  info?: React.ReactNode;
  ref?: React.RefObject<HTMLDivElement | null>;
}

export type StatProps = StatRootProps;

export function StatLabel({ ref, ...props }: StatLabelProps) {
  const { info, children, ...rest } = props;
  return (
    <ChakraStatNamespace.Label {...rest} ref={ref}>
      {children}
    </ChakraStatNamespace.Label>
  );
}

interface StatValueTextProps extends Omit<ChakraStatNamespace.ValueTextProps, 'children'> {
  value?: number;
  formatOptions?: FormatValueProps;
  children: ReactNode | Iterable<ReactNode>;
  ref?: React.RefObject<HTMLDivElement | null>;
}

export function StatValueText({ ref, ...props }: StatValueTextProps) {
  const { value, formatOptions, children, ...rest } = props;
  return (
    <ChakraStatNamespace.ValueText {...rest} ref={ref}>
      {children || (value != null && <FormatValue value={value} {...formatOptions} />)}
    </ChakraStatNamespace.ValueText>
  );
}

export interface StatTrendProps extends Omit<StackProps, 'children'> {
  ref?: RefObject<HTMLDivElement | null>;
  children?: ReactNode;
}

export function StatUpTrend({ ref, ...props }: StatTrendProps) {
  return (
    <HStack gap={1} ref={ref} alignItems="baseline" {...props}>
      <ChakraStatNamespace.UpIndicator />
      {props.children}
    </HStack>
  );
}

export function StatDownTrend({ ref, ...props }: StatTrendProps) {
  return (
    <HStack gap={1} ref={ref} alignItems="baseline" {...props}>
      <ChakraStatNamespace.DownIndicator />
      {props.children}
    </HStack>
  );
}

export const StatRoot = ChakraStatNamespace.Root;

export interface StatHelpTextProps extends ChakraStatNamespace.HelpTextProps {
  ref?: RefObject<HTMLDivElement | null>;
}
export function StatHelpText({ ref, ...props }: StatTrendProps) {
  return <ChakraStatNamespace.HelpText {...props} role="definition" ref={ref} />;
}
export const StatValueUnit = ChakraStatNamespace.ValueUnit;
